import React from 'react';

import { FormattedMessage } from 'react-intl';

import { Checkbox } from '@atlaskit/checkbox';
import { Box, Stack, Inline, Text } from '@atlaskit/primitives';

import { ActivityApi } from 'src/components/activity/types';

import { messages } from './pull-request-activity-events.i18n';

type MultiTaskProps = {
  event: ActivityApi['TaskActivity'][];
};

export const PullRequestTasksTitle = ({ event }: MultiTaskProps) => {
  const task = event[0];
  const { action } = task.task;
  const count = event.length;
  return (
    <FormattedMessage
      values={{ count }}
      {...(action === 'CREATED'
        ? messages.tasksCreatedEventTitle
        : messages.tasksResolvedEventTitle)}
    />
  );
};

export const PullRequestTasksBody = ({ event }: MultiTaskProps) => {
  // naming is hard
  const tasks = event;

  return (
    <Box paddingInlineStart="space.400">
      <Stack>
        {tasks.map((task, index) => {
          return (
            <Inline alignBlock="center" key={index}>
              <Checkbox
                isChecked={task.task.action === 'RESOLVED'}
                isDisabled
              />
              <Text>{task.task.task.content.raw}</Text>
            </Inline>
          );
        })}
      </Stack>
    </Box>
  );
};
